import { faqCusto, faqDados, faqProgramar, faqSistema } from './shared'
import type { ProfessionPageConfig } from './types'

export const contadores: ProfessionPageConfig = {
  path: '/ia-para-contadores/',
  key: 'contadores',
  title: 'IA para contadores e escritórios de contabilidade | Oficina IA',
  description:
    'Três tarefas do escritório contábil que a IA adianta numa pasta: conferir notas contra o extrato, organizar documentos por cliente e avisar vencimentos.',
  imageAlt: 'Oficina IA: IA para contadores',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para contadores e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para contadores',
  intro:
    'Todo mês a mesma pilha: notas, extratos, documentos de cliente chegando de todo jeito. Aqui estão três tarefas dessa pilha que a IA pode ajudar a adiantar, sem trocar o seu sistema e sem programar.',
  rogerio: { pose: 'conferindo', text: 'Eu confiro o extrato. Você confere o que não bateu.' },
  tasks: [
    {
      title: 'Notas conferidas contra o extrato',
      tone: 'sky',
      brings: 'as notas do mês e o extrato do banco, em arquivo.',
      helps: 'bate um com o outro e separa o que não fechou.',
      continues: 'uma lista curta do que conferir, em vez da pilha inteira.',
    },
    {
      title: 'Documentos por cliente e por mês',
      tone: 'peach',
      brings: 'uma pasta com tudo misturado: notas, guias, comprovantes.',
      helps: 'renomeia, separa por cliente e por competência e faz um índice.',
      continues: 'cada pasta no lugar, pronta para o fechamento.',
    },
    {
      title: 'Avisos de vencimento',
      tone: 'sage',
      brings: 'a planilha de obrigações e a lista de clientes.',
      helps: 'escreve um aviso por cliente, com o que vence e quando.',
      continues: 'revisa, ajusta o tom e envia.',
    },
  ],
  steps: {
    do: 'A IA prepara a conferência, a pasta organizada ou os avisos dentro da sua pasta.',
    check: 'Abra o que não bateu e confira com o documento. A IA pode se enganar; o fechamento é seu.',
    resume: 'No mês seguinte, troque as notas e o extrato e repita o pedido.',
  },
  faq: [faqProgramar, faqSistema('sistema contábil'), faqDados('dos clientes'), faqCusto],
  closing: {
    title: 'Sua primeira conferência, com alguém do lado.',
    text: 'Traga o extrato que fecha à noite ou a pasta do cliente que chega bagunçada.',
    rogerio: 'Eu cuido do novelo. Você cuida do fechamento.',
  },
}
